define('ch_accordion',['jquery'], function($) {
    return {
        init: function () {
            $('.accordion-mobile').each(function(i, el) {
                var $header = $(el).find('.accordion-header');
                var $content = $(el).find('.accordion-content');

                if (!$header.find('.icon.dropdown').length) {
                    $header.append('<i class="ui icon dropdown"></i>');
                }

                $header.on('click', function(e) {
                    $content.slideToggle();
                });

                // default hidden
                if (!$(this).hasClass('accordion-mobile-active')) {
                    $content.hide();
                }
            });
        }
    }
});

